import { send, validateSerial } from '../../common/utils';
import { HUB_SCENES_EDIT } from '../../common/methods';

/**
 * Edits an existing scene/rule on the specified hub via WebSocket API.
 * This is the low-level API function that validates the serial and sends the WebSocket message.
 *
 * @param {string} serial - Hub serial number (e.g., "90004631")
 * @param {Object} params - Scene/rule parameters object
 * @param {string} params._id - Unique identifier of the scene/rule to edit
 * @param {Object} params.eo - Full scene/rule configuration object
 * @param {Function} onSuccess - Callback function called when the API request succeeds
 * @param {Function} onError - Callback function called when the API request fails
 *
 * @returns {*} Returns the result of the send function (usually the WebSocket message)
 *
 * @throws {Error} Throws validation error if serial is invalid
 *
 * @example
 * hubScenesEditApi(
 *   "90004631",
 *   { _id: "scene-abc123", eo: { name: "Motion Alert", enabled: true, ... } },
 *   (response) => console.log('Success:', response),
 *   (error) => console.error('Error:', error)
 * );
 */
const hubScenesEditApi = (serial, params, onSuccess, onError) => {
    validateSerial(serial);

    return send(serial, HUB_SCENES_EDIT, params, onSuccess, onError);
};

/**
 * Alias for hubScenesEditApi function.
 * Edits an existing scene/rule on the specified hub via WebSocket API.
 *
 * @param {string} serial - Hub serial number
 * @param {Object} params - Scene/rule parameters object (see hubScenesEditApi for structure)
 * @param {Function} onSuccess - Success callback function
 * @param {Function} onError - Error callback function
 * @returns {*} Returns the result of hubScenesEditApi
 * @see {[hub.scenes.edit](https://log.ezlo.com/public/hub/scenes/local_scenes_api/#hubscenesedit)}
 *
 * @example
 * edit("90004631", { _id: "scene-abc123", eo: ruleConfig }, onSuccess, onError);
 */
export { hubScenesEditApi as edit };
